import { tabNameList } from './config'
import i18n from '@ps/lang'

export const tabTypeList = {
  image: {
    [tabNameList.commonImage]: {
      text: i18n.t(
        'workbench.resourceManagers.categoryList.image.commonImage',
      ) as string,
      key: tabNameList.commonImage,
    },
    [tabNameList.assetImage]: {
      text: i18n.t('workbench.resourceManagers.dialog.assetLibrary') as string,
      key: tabNameList.assetImage,
    },
  },
  audio: {
    [tabNameList.commonAudio]: {
      text: i18n.t('basic.resourceManager.commonAudio') as string,
      key: tabNameList.commonAudio,
    },
    [tabNameList.assetAudio]: {
      text: i18n.t('workbench.resourceManagers.dialog.assetLibrary') as string,
      key: tabNameList.assetAudio,
    },
  },
  bgm: {
    [tabNameList.commonBgm]: {
      text: i18n.t('basic.resourceManager.commonBgm') as string,
      key: tabNameList.commonBgm,
    },
    [tabNameList.assetAudio]: {
      text: i18n.t('workbench.resourceManagers.dialog.assetLibrary') as string,
      key: tabNameList.assetAudio,
    },
  },
  video: {
    [tabNameList.commonVideo]: {
      text: i18n.t('basic.resourceManager.commonVideo') as string,
      key: tabNameList.commonVideo,
    },
    [tabNameList.assetVideo]: {
      text: i18n.t('workbench.resourceManagers.dialog.assetLibrary') as string,
      key: tabNameList.assetVideo,
    },
  },
  seqframe: {
    [tabNameList.commonFrameSequence]: {
      text: i18n.t('basic.resourceManager.commonAImage') as string,
      key: tabNameList.commonFrameSequence,
    },
    [tabNameList.assetFrameSequence]: {
      text: i18n.t('workbench.resourceManagers.dialog.assetLibrary') as string,
      key: tabNameList.assetFrameSequence,
    },
  },
  model: {
    [tabNameList.commonModel]: {
      text: i18n.t('basic.resourceManager.commonModel') as string,
      key: tabNameList.commonModel,
    },
    [tabNameList.assetModel]: {
      text: i18n.t('workbench.resourceManagers.dialog.assetLibrary') as string,
      key: tabNameList.assetModel,
    },
  },
  action: {
    [tabNameList.commonAction]: {
      text: i18n.t('basic.resourceManager.commonAction') as string,
      key: tabNameList.commonAction,
    },
  },
}

export const getToolKey = (type: string) => {
  // pt 工具：1
  return 1
}

export const getTypeKey = (type: string) => {
  switch (type) {
    case 'image':
      return 1
    case 'seqframe':
      return 2
    case 'audio':
      return 3
    case 'bgm':
      return 4
    case 'video':
      return 6
    case 'model':
      return 14
    case 'action':
      return 15
    default:
      return 1
  }
}
